import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SocialWelcomeModal from "../../components/Modal/SocialWelcomeModal";
import ReactGA from "react-ga4";
import useIPhoneBackFixGlobal from "../../hooks/useIphoneBackFix";
import SeoHead from "../../seo/SeoHead";

const Homepage = lazy(() => import("../HomePage/HomePage"));
const TeamSinglePage = lazy(() => import("../TeamSinglePage/TeamSinglePage"));
const ProjectSingle = lazy(() => import("../ProjectSingle/ProjectSingle"));
const ServicePages = lazy(() => import("../ServicePage/ServicePage"));
const ServicePageLkk = lazy(() => import("../ServicePage/ServicePageLkk"));
const ServiceSinglePage = lazy(() =>
  import("../ServiceSinglePage/ServiceSinglePage")
);
const ContactPage = lazy(() => import("../ContactPage/ContactPage"));
const ResultsPage = lazy(() => import("../ResultsPage/ResultsPage"));
const ErrorPage = lazy(() => import("../ErrorPage/ErrorPage"));
const DoctorsPage = lazy(() => import("../DoctorsPage/DoctorsPage"));
const SpecialistsPage = lazy(() => import("../SpecialistsPage/SpecialistsPage"));
const DoctorSinglePage = lazy(() =>
  import("../DoctorSinglePage/DoctorSinglePage")
);
const LaboratoryPage = lazy(() => import("../LaboratoryPage/LaboratoryPage"));

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);

  return null;
}

function IPhoneBackFixTracker() {
  useIPhoneBackFixGlobal();
  return null;
}

const AllRoute = () => {
  return (
    <div className="App">
      <SocialWelcomeModal />
      <BrowserRouter>
        <SeoHead />
        <AnalyticsTracker />
        <IPhoneBackFixTracker />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route
              path="lichni-lekari-montana"
              element={<DoctorsPage />}
            />
            <Route
              path="lichen-lekar-montana/:slug"
              element={<DoctorSinglePage />}
            />
            <Route path="laboratoriq-montana" element={<LaboratoryPage />} />
            <Route path="spetsialisti-montana" element={<SpecialistsPage />} />
            <Route path="specialnosti" element={<ServicePages />} />
            <Route path="specialnosti-lkk" element={<ServicePageLkk />} />
            <Route path="gost-lekar/:slug" element={<TeamSinglePage />} />
            <Route
              path="meditsintska-specialnost-montana/:slug"
              element={<ServiceSinglePage />}
            />
            <Route
              path="dopulnitelni-meditsinski-uslugi/:slug"
              element={<ProjectSingle />}
            />
            <Route path="contact" element={<ContactPage />} />
            <Route path="results" element={<ResultsPage />} />
            <Route path="404" element={<ErrorPage />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
